"use strict";
const { getQueryString, fillParams } = require("@fe/common/lib/utils.js");
require("./index.scss");

const utils = require("@fe/common/lib/utils.js");
// 统计点击
const ga = utils._ga;
const downLoadObj = {
  youtube: {
    btnWord: "YOUTUBE",
    name: "Youtube",
    svga: "/public/svga/youtube.svga",
    noAppText: 'Open failed, please check your Youtube App.'
  },
  facebook: {
    btnWord: "FACEBOOK",
    name: "Facebook",
    svga: "/public/svga/fb.svga",
    noAppText: 'Open failed, please check your Facebook App.'
  },
  instagram: {
    btnWord: "INSTAGRAM",
    name: "Instagram",
    svga: "/public/svga/ins.svga",
    noAppText: 'Open failed, please check your Instagram App.'
  },
};
let downList = ['youtube', 'facebook', 'instagram']
window.currentIndex = 0
let direction = ''
let startX, startY, moveEndX, moveEndY, X, Y, mathabsX, mathabsY;
let checkoutInstall = false; // 是否安装 PT, 跳出当前页表示 已安装
let isInstallApp = false;
let loadingTimer = false;

/**
 * dom节点加载完毕事件
 */
$(document).ready(function () {
  let search = location.href;
  let page = getQueryString("page", search) || "youtube";
  let lang = getQueryString("lang", search);

  // 获取阿语数据
  const getArData = () => {
    window.location.href = fillParams({
      page: window.currentType,
      lang: "ar",
    });
  };

  function checkAr() {
    // if has lang return
    if (lang) return;
    let sLang = navigator.language;
    let gLanguage = getQueryString("gLanguage", search);
    let gPLanguage = getQueryString("gPLanguage", search);
    if (window.vbrowser && window.vbrowser.getClientData("language")) {
      let wlang = window.vbrowser.getClientData("language");
      if (Object.is(wlang, "ar")) {
        // 当前语言为阿语 请求对应数据重新渲染
        getArData();
      }
    } else if (
      Object.is(lang, "ar") ||
      (sLang && sLang.includes("ar")) ||
      Object.is(gLanguage, "ar") ||
      Object.is(gPLanguage, "ar")
    ) {
      getArData();
    }
  }

  // left right
  function turnLeftRight() {

    $("body").on("touchstart", function (e) {
      // e.preventDefault();
      startX = e.changedTouches[0].pageX;
      startY = e.changedTouches[0].pageY;
    });
    $("body").on("touchmove", function (e) {
      // e.preventDefault();
      moveEndX = e.changedTouches[0].pageX;
      moveEndY = e.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;
      mathabsX = Math.abs(X)
      mathabsY = Math.abs(Y)
      if (mathabsX > mathabsY && X > 0) {
        direction = 'left'
        // console.log("left 2 right", mathabsX, underlineWidth, currentTab);
      } else if (mathabsX > mathabsY && X < 0) {
        direction = 'right'
        // console.log("right 2 left", mathabsX, underlineWidth);
      } else {
        direction = ''
      }
    });
    $("body").on("touchend", function (e) {
      let index = window.currentIndex
      if(direction == 'left') {
        if(index > 0) {
          index -= 1
        }
      } else if(direction == 'right') {
        if(index < downList.length - 1) {
          index += 1
        }
      }
      if(direction && index !== window.currentIndex) {
        ga(`downloadGuide_slide_tab`);
        document.querySelectorAll('.js_change_nav')[index].click()
      }
      direction = ''
    })
  }

  // check country or appid, extends youtue
  function checkTab() {
    if (window.vbrowser) {
      let country = window.vbrowser.getClientData("country")
      let appId = window.vbrowser.getClientData("appid")
      if (appId == "false") {
        appId = window.vbrowser.getClientData("cha");
      }
      if(['UM','US','CN'].indexOf(country.toUpperCase()) >=0 || appId == 'com.nemo.vidmate.app.itelstore') {
        $('.js_change_nav[data-type="youtube"]').remove()
        $('.js_change_nav[data-type="facebook"]').addClass('sn-item-active')
        page = 'facebook'
        downList = ['facebook', 'instagram']
      }
    } 
  }

  checkTab()
  checkAr();
  turnLeftRight();
  // main Fun
  loadSvgAndWord(page);

  // downbtn click
  $("#js_down_btn").on("click", function () {
    let a = document.createElement("a");
    a.setAttribute("id", "js_deeplink");
    toggleLoding(true)
    if (document.getElementById("js_deeplink")) {
      document.body.removeChild(document.getElementById("js_deeplink"));
    }
    if (window.currentType == "facebook") {
      a.setAttribute("href", "fb://");
    } else if (window.currentType == "instagram") {
      a.setAttribute("href", "instagram://share");
    } else {
      a.setAttribute("href", "vnd.youtube://");
    }
    ga(`downloadGuide_${window.currentType}_${lang || "en"}_btn`);
    document.body.appendChild(a);
    a.click();
    playVideo()
  });

  $(".js_change_nav").on("click", function (e) {
    let type = e.target.dataset.type;
    loadSvgAndWord(type);
    $(this).addClass("sn-item-active").siblings().removeClass("sn-item-active");
  });

  /**
   * 监听跳出页面事件，实现唤起APP后，回到当前页不再出现弹层
   */
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'hidden') {
      if (checkoutInstall) {
        checkoutInstall = false;
        isInstallApp = true;
      } else {
        isInstallApp = false;
      }
    }
  });
});

function toggleLoding(isShow) {
  if(isShow) {
    $("#js_tips").show();
  } else {
    $("#js_tips").hide();
  }
}
function toggleToast(isShow, text) {
  if(isShow) {
    $('#js_toast').show()
    $('#js_toast_text').text(text)
    setTimeout(function() {
      $('#js_toast').hide()
    }, 2500)
  } else {
    $('#js_toast').hide()
  }
}
function playVideo() {
  checkoutInstall = true;
  clearTimeout(loadingTimer);
  loadingTimer = setTimeout(function(){
    checkoutInstall = false;
    toggleLoding(false)
    if (!isInstallApp) {
      toggleToast(true, downLoadObj[window.currentType].noAppText)
      ga(`downloadGuide_${window.currentType}_failed`);
    } else {
      isInstallApp = false;
    }
  }, 1500);
}

function loadSvgAndWord(type) {
  // 加载svga
  let player = new SVGA.Player("#js_canvas");
  let parser = new SVGA.Parser("#js_canvas");
  if(downLoadObj[type].svgaData) {
    player.loops = 0;
    player.clearsAfterStop = false;
    player.setVideoItem(downLoadObj[type].svgaData);
    player.startAnimation();
  } else {
    parser.load(downLoadObj[type].svga, function (videoItem) {
      player.loops = 0;
      player.clearsAfterStop = false;
      player.setVideoItem(videoItem);
      player.startAnimation();
      downLoadObj[type].svgaData = videoItem
    });
  }
  if (window.currentType != type) {
    $("#js_word_name").text(downLoadObj[type].name);
    $("#js_btn_name").text(downLoadObj[type].btnWord);
    $("#js_down_btn")
      .removeClass(`${window.currentType}-btn`)
      .addClass(`${type}-btn`);
    window.currentType = type;
    window.currentIndex = downList.indexOf(type)
  }
}
